import { NetworkError } from '../api/errors';
import { useT } from '../i18n';

export function ErrorBanner({ error, onRetry }: { error: unknown; onRetry?: () => void }) {
  const t = useT();
  const message = error instanceof NetworkError ? t.errors.network : t.errors.generic;
  return (
    <div className="flex items-center justify-between gap-3 rounded-xl bg-secondary-bg px-4 py-3 text-sm">
      <span>{message}</span>
      {onRetry && (
        <button type="button" className="font-medium text-link" onClick={onRetry}>
          {t.errors.retry}
        </button>
      )}
    </div>
  );
}
